export default function fnUpdateArr(arr, id, updatedData) {
  return arr.map((item) =>
    item.id === id ? { ...item, ...updatedData } : item
  )
}
